'use client';

import { useEffect } from 'react';

export default function ClientAnalytics() {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      // Inicializar Google Ads
      const adsScript = document.createElement('script');
      adsScript.type = 'text/javascript';
      adsScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-17161209946');

        function gtag_report_conversion(url) {
          gtag('event', 'custom_widget', {
              'send_to': 'AW-17161209946/OoojCKaTnuYaENqQjfc_'
          });
        }
      `;
      document.body.appendChild(adsScript);

      // Observar cambios en el DOM para rastrear calendly-badge-content
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.addedNodes.length) {
            // Buscar el elemento calendly-badge-content
            const calendlyContent = document.querySelector('.calendly-badge-content');
            if (calendlyContent) {
              // Remover cualquier evento existente
              (calendlyContent as HTMLElement).removeEventListener('click', handleCalendlyClick);
              // Agregar evento una sola vez
              (calendlyContent as HTMLElement).addEventListener('click', handleCalendlyClick, { once: true });
            }
          }
        });
      });

      // Función para manejar el clic en Calendly
      const handleCalendlyClick = () => {
        if (typeof window.gtag_report_conversion === 'function') {
          window.gtag_report_conversion();
          // Deshabilitar el elemento temporalmente
          const element = document.querySelector('.calendly-badge-content') as HTMLElement;
          if (element) {
            element.style.pointerEvents = 'none';
            setTimeout(() => {
              element.style.pointerEvents = 'auto';
            }, 3000); // Restaurar después de 3 segundos
          }
        }
      };

      // Observar cambios en el DOM
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      // Observar cambios en el DOM
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      // Cleanup on unmount
      return () => {
        document.body.removeChild(adsScript);
        observer.disconnect();
      };
    }
  }, []);

  return null;
}
